import { render, staticRenderFns } from "./MyAppointment.vue?vue&type=template&id=8c1dd762&scoped=true"
import script from "./MyAppointment.vue?vue&type=script&lang=js"
export * from "./MyAppointment.vue?vue&type=script&lang=js"
import style0 from "./MyAppointment.vue?vue&type=style&index=0&id=8c1dd762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1dd762",
  null
  
)

export default component.exports